module.exports = __webpack_public_path__ + "static/blue-arrow-f0d37cef2470a305d81c797391d71e41.webp";